// Generated by purs version 0.15.12
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_List_Lazy from "../Data.List.Lazy/index.js";
import * as Data_List_Lazy_Types from "../Data.List.Lazy.Types/index.js";
import * as Data_LoadDirection from "../Data.LoadDirection/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_TcpStatsResult from "../Data.TcpStatsResult/index.js";
import * as Data_TransmissionStats from "../Data.TransmissionStats/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_UUID_Random from "../Data.UUID.Random/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Class_MonadApp from "../Fusion.Class.MonadApp/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_FSValue from "../Fusion.Data.FSValue/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_DataProcessing from "../Fusion.DataProcessing/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Data_EngineCommunication from "../MST.Data.EngineCommunication/index.js";
import * as MST_Data_StreamEvent from "../MST.Data.StreamEvent/index.js";
import * as MST_Data_Units from "../MST.Data.Units/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
import * as URI_Path_Segment from "../URI.Path.Segment/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
import * as WE_Class_Random from "../WE.Class.Random/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var speedIsSymbol = {
    reflectSymbol: function () {
        return "speed";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(speedIsSymbol);
var timestampIsSymbol = {
    reflectSymbol: function () {
        return "timestamp";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(timestampIsSymbol)(Fusion_Data_Timestamp.showTimestamp);
var showRecordFieldsCons1 = /* #__PURE__ */ showRecordFieldsCons(showRecordFieldsConsNil)(Fusion_Data_Speed.showSpeed);
var showRecord1 = /* #__PURE__ */ showRecord(showRecordFieldsCons1);
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showRecord1));
var genericShowConstructor2 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_TransmissionStats.showTransmissionStats));
var bytesIsSymbol = {
    reflectSymbol: function () {
        return "bytes";
    }
};
var streamSpeedsIsSymbol = {
    reflectSymbol: function () {
        return "streamSpeeds";
    }
};
var totalSpeedIsSymbol = {
    reflectSymbol: function () {
        return "totalSpeed";
    }
};
var CurrentIsSymbol = {
    reflectSymbol: function () {
        return "Current";
    }
};
var TotalIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "TotalIntermediate";
    }
};
var streamIndexIsSymbol = {
    reflectSymbol: function () {
        return "streamIndex";
    }
};
var showRecordFieldsCons2 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(streamIndexIsSymbol);
var StreamIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "StreamIntermediate";
    }
};
var IntermediateStatsPassiveIsSymbol = {
    reflectSymbol: function () {
        return "IntermediateStatsPassive";
    }
};
var IntermediateStatsActiveIsSymbol = {
    reflectSymbol: function () {
        return "IntermediateStatsActive";
    }
};
var warningIsSymbol = {
    reflectSymbol: function () {
        return "warning";
    }
};
var WarningIsSymbol = {
    reflectSymbol: function () {
        return "Warning";
    }
};
var jitterIsSymbol = {
    reflectSymbol: function () {
        return "jitter";
    }
};
var statsActiveIsSymbol = {
    reflectSymbol: function () {
        return "statsActive";
    }
};
var statsPassiveIsSymbol = {
    reflectSymbol: function () {
        return "statsPassive";
    }
};
var FinalIsSymbol = {
    reflectSymbol: function () {
        return "Final";
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Bytes.eqBytes);
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(timestampIsSymbol)(Fusion_Data_Timestamp.eqTimestamp))()(speedIsSymbol)(Fusion_Data_Speed.eqSpeed))));
var eq2 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Speed.eqSpeed);
var eq3 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Timestamp.eqTimestamp);
var eq5 = /* #__PURE__ */ Data_Eq.eq(Data_TransmissionStats.eqTransmissionStats);
var eq6 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_FSValue.eqFSWarning);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Speed.encodeJsonSpeed);
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Timestamp.encodeJsonTimestamp);
var gEncodeJsonCons2 = /* #__PURE__ */ gEncodeJsonCons1(Data_Argonaut_Encode_Class.gEncodeJsonNil)(timestampIsSymbol)();
var encodeRecord = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(gEncodeJsonCons2)(speedIsSymbol)())();
var gEncodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt);
var encodeRepArgsArgument = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_TransmissionStats.encodeJsonTransmissionSta);
var gEncodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_TransmissionStats.encodeJsonTransmissionSta);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Speed.decodeJsonSpeed));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Timestamp.decodeJsonTimestamp));
var gDecodeJsonCons2 = /* #__PURE__ */ gDecodeJsonCons1(Data_Argonaut_Decode_Class.gDecodeJsonNil)(timestampIsSymbol)()();
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(gDecodeJsonCons2)(speedIsSymbol)()())();
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt));
var gDecodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_TransmissionStats.decodeJsonTransmissionSta));
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Monoid.monoidRecord()(/* #__PURE__ */ Data_Monoid.monoidRecordCons(bytesIsSymbol)(Fusion_Data_Bytes.monoidBytes)()(Data_Monoid.monoidRecordNil)));
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "error";
    }
})(MST_Data_EngineCommunication.showEngineResponseError)));
var eq7 = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(MST_Data_Units.ordStreamId);
var notEq = /* #__PURE__ */ Data_Eq.notEq(MST_Data_StreamEvent.eqStreamEventPayload);
var show1 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "payload";
    }
})(showRecordFieldsConsNil)(MST_Data_StreamEvent.showStreamEventPayload)));
var show2 = /* #__PURE__ */ Data_Show.show(Fusion_Data_FSError.showFSError);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Speed.monoidSpeed);
var mempty2 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Bytes.monoidBytes);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Lazy_Types.foldableList);
var fromFoldable1 = /* #__PURE__ */ Data_List_Lazy.fromFoldable(Data_Array_NonEmpty_Internal.foldableNonEmptyArray);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var updateAtIndices = /* #__PURE__ */ Data_Array.updateAtIndices(Data_Foldable.foldableArray);
var fold = /* #__PURE__ */ Data_Array.fold(Fusion_Data_Speed.monoidSpeed);
var max = /* #__PURE__ */ Data_Ord.max(Fusion_Data_Timestamp.ordTimestamp);
var mempty3 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Fusion_Data_Bytes.semigroupBytes);
var add = /* #__PURE__ */ Data_Semiring.add(Data_Semiring.semiringInt);
var Completed = /* #__PURE__ */ (function () {
    function Completed() {

    };
    Completed.value = new Completed();
    return Completed;
})();
var Aborted = /* #__PURE__ */ (function () {
    function Aborted() {

    };
    Aborted.value = new Aborted();
    return Aborted;
})();
var Failed = /* #__PURE__ */ (function () {
    function Failed(value0) {
        this.value0 = value0;
    };
    Failed.create = function (value0) {
        return new Failed(value0);
    };
    return Failed;
})();
var SLOCurrent = /* #__PURE__ */ (function () {
    function SLOCurrent(value0) {
        this.value0 = value0;
    };
    SLOCurrent.create = function (value0) {
        return new SLOCurrent(value0);
    };
    return SLOCurrent;
})();
var SLOIntermediate = /* #__PURE__ */ (function () {
    function SLOIntermediate(value0) {
        this.value0 = value0;
    };
    SLOIntermediate.create = function (value0) {
        return new SLOIntermediate(value0);
    };
    return SLOIntermediate;
})();
var SLOIntermediateStatsPassive = /* #__PURE__ */ (function () {
    function SLOIntermediateStatsPassive(value0) {
        this.value0 = value0;
    };
    SLOIntermediateStatsPassive.create = function (value0) {
        return new SLOIntermediateStatsPassive(value0);
    };
    return SLOIntermediateStatsPassive;
})();
var SLOIntermediateStatsActive = /* #__PURE__ */ (function () {
    function SLOIntermediateStatsActive(value0) {
        this.value0 = value0;
    };
    SLOIntermediateStatsActive.create = function (value0) {
        return new SLOIntermediateStatsActive(value0);
    };
    return SLOIntermediateStatsActive;
})();
var SLOFinished = /* #__PURE__ */ (function () {
    function SLOFinished(value0) {
        this.value0 = value0;
    };
    SLOFinished.create = function (value0) {
        return new SLOFinished(value0);
    };
    return SLOFinished;
})();
var Current = /* #__PURE__ */ (function () {
    function Current(value0) {
        this.value0 = value0;
    };
    Current.create = function (value0) {
        return new Current(value0);
    };
    return Current;
})();
var TotalIntermediate = /* #__PURE__ */ (function () {
    function TotalIntermediate(value0) {
        this.value0 = value0;
    };
    TotalIntermediate.create = function (value0) {
        return new TotalIntermediate(value0);
    };
    return TotalIntermediate;
})();
var StreamIntermediate = /* #__PURE__ */ (function () {
    function StreamIntermediate(value0) {
        this.value0 = value0;
    };
    StreamIntermediate.create = function (value0) {
        return new StreamIntermediate(value0);
    };
    return StreamIntermediate;
})();
var IntermediateStatsPassive = /* #__PURE__ */ (function () {
    function IntermediateStatsPassive(value0) {
        this.value0 = value0;
    };
    IntermediateStatsPassive.create = function (value0) {
        return new IntermediateStatsPassive(value0);
    };
    return IntermediateStatsPassive;
})();
var IntermediateStatsActive = /* #__PURE__ */ (function () {
    function IntermediateStatsActive(value0) {
        this.value0 = value0;
    };
    IntermediateStatsActive.create = function (value0) {
        return new IntermediateStatsActive(value0);
    };
    return IntermediateStatsActive;
})();
var Warning = /* #__PURE__ */ (function () {
    function Warning(value0) {
        this.value0 = value0;
    };
    Warning.create = function (value0) {
        return new Warning(value0);
    };
    return Warning;
})();
var Final = /* #__PURE__ */ (function () {
    function Final(value0) {
        this.value0 = value0;
    };
    Final.create = function (value0) {
        return new Final(value0);
    };
    return Final;
})();
var isFinalStreamLoadOutput = {
    isFinal: function (v) {
        if (v instanceof SLOCurrent) {
            return false;
        };
        if (v instanceof SLOIntermediate) {
            return false;
        };
        if (v instanceof SLOIntermediateStatsPassive) {
            return false;
        };
        if (v instanceof SLOIntermediateStatsActive) {
            return false;
        };
        if (v instanceof SLOFinished) {
            return true;
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 636, column 13 - line 641, column 26): " + [ v.constructor.name ]);
    }
};
var isFinalLoadOutput = {
    isFinal: function (v) {
        if (v instanceof Current) {
            return false;
        };
        if (v instanceof TotalIntermediate) {
            return false;
        };
        if (v instanceof StreamIntermediate) {
            return false;
        };
        if (v instanceof IntermediateStatsPassive) {
            return false;
        };
        if (v instanceof IntermediateStatsActive) {
            return false;
        };
        if (v instanceof Warning) {
            return false;
        };
        if (v instanceof Final) {
            return true;
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 626, column 13 - line 633, column 20): " + [ v.constructor.name ]);
    }
};
var genericStreamLoadOutput_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new SLOCurrent(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new SLOIntermediate(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new SLOIntermediateStatsPassive(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new SLOIntermediateStatsActive(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return new SLOFinished(x.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 617, column 1 - line 617, column 43): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof SLOCurrent) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof SLOIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof SLOIntermediateStatsPassive) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof SLOIntermediateStatsActive) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof SLOFinished) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))));
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 617, column 1 - line 617, column 43): " + [ x.constructor.name ]);
    }
};
var genericStreamCompletionMa = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Completed.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Aborted.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new Failed(x.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 621, column 1 - line 621, column 49): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Completed) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Aborted) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Failed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 621, column 1 - line 621, column 49): " + [ x.constructor.name ]);
    }
};
var showStreamCompletionManne = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStreamCompletionMa)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Completed";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Aborted";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "Failed";
        }
    }))))
};
var showStreamLoadOutput = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStreamLoadOutput_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "loadedBytes";
        }
    })(showRecordFieldsCons1)(Fusion_Data_Bytes.showBytes))))({
        reflectSymbol: function () {
            return "SLOCurrent";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1({
        reflectSymbol: function () {
            return "SLOIntermediate";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2({
        reflectSymbol: function () {
            return "SLOIntermediateStatsPassive";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2({
        reflectSymbol: function () {
            return "SLOIntermediateStatsActive";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showStreamCompletionManne))({
        reflectSymbol: function () {
            return "SLOFinished";
        }
    }))))))
};
var genericLoadOutput_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Current(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new TotalIntermediate(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new StreamIntermediate(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new IntermediateStatsPassive(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new IntermediateStatsActive(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new Warning(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return new Final(x.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 604, column 1 - line 604, column 37): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Current) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof TotalIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof StreamIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof IntermediateStatsPassive) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof IntermediateStatsActive) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof Warning) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof Final) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
        };
        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 604, column 1 - line 604, column 37): " + [ x.constructor.name ]);
    }
};
var showLoadOutput = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericLoadOutput_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(bytesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(streamSpeedsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(totalSpeedIsSymbol)(showRecord1))(/* #__PURE__ */ Data_Show.showArray(showRecord1)))(Fusion_Data_Bytes.showBytes))))(CurrentIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(TotalIntermediateIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ showRecordFieldsCons2(showRecordFieldsConsNil)(Data_Show.showInt))(Fusion_Data_Speed.showSpeed))))(StreamIntermediateIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(IntermediateStatsPassiveIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(IntermediateStatsActiveIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ Data_Show.showRecordFieldsCons(timestampIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(warningIsSymbol)(Fusion_Data_FSValue.showFSWarning))(Fusion_Data_Timestamp.showTimestamp))(Data_Show.showInt))))(WarningIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(jitterIsSymbol)(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsCons(statsActiveIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(statsPassiveIsSymbol)(Data_TransmissionStats.showTransmissionStats))(Data_TransmissionStats.showTransmissionStats))(Fusion_Data_Speed.showSpeed))(Fusion_Data_Speed.showSpeed))))(FinalIsSymbol))))))))
};
var eqLoadOutput = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Current && y instanceof Current) {
                return eq(x.value0.bytes)(y.value0.bytes) && eq1(x.value0.streamSpeeds)(y.value0.streamSpeeds) && (eq2(x.value0.totalSpeed.speed)(y.value0.totalSpeed.speed) && eq3(x.value0.totalSpeed.timestamp)(y.value0.totalSpeed.timestamp));
            };
            if (x instanceof TotalIntermediate && y instanceof TotalIntermediate) {
                return eq2(x.value0.speed)(y.value0.speed) && eq3(x.value0.timestamp)(y.value0.timestamp);
            };
            if (x instanceof StreamIntermediate && y instanceof StreamIntermediate) {
                return eq2(x.value0.speed)(y.value0.speed) && x.value0.streamIndex === y.value0.streamIndex && eq3(x.value0.timestamp)(y.value0.timestamp);
            };
            if (x instanceof IntermediateStatsPassive && y instanceof IntermediateStatsPassive) {
                return eq5(x.value0)(y.value0);
            };
            if (x instanceof IntermediateStatsActive && y instanceof IntermediateStatsActive) {
                return eq5(x.value0)(y.value0);
            };
            if (x instanceof Warning && y instanceof Warning) {
                return x.value0.streamIndex === y.value0.streamIndex && eq3(x.value0.timestamp)(y.value0.timestamp) && eq6(x.value0.warning)(y.value0.warning);
            };
            if (x instanceof Final && y instanceof Final) {
                return eq2(x.value0.jitter)(y.value0.jitter) && eq2(x.value0.speed)(y.value0.speed) && eq5(x.value0.statsActive)(y.value0.statsActive) && eq5(x.value0.statsPassive)(y.value0.statsPassive);
            };
            return false;
        };
    }
};
var encodeJsonLoadOutput = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericLoadOutput_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(CurrentIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Bytes.encodeJsonBytes)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encodeRecord))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeRecord)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(totalSpeedIsSymbol)())(streamSpeedsIsSymbol)())(bytesIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(TotalIntermediateIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(encodeRecord)))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StreamIntermediateIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons3(gEncodeJsonCons2)(streamIndexIsSymbol)())(speedIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(IntermediateStatsPassiveIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(IntermediateStatsActiveIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(WarningIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_FSValue.encodeJsonFSWarning)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(warningIsSymbol)())(timestampIsSymbol)())(streamIndexIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(FinalIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons4(/* #__PURE__ */ gEncodeJsonCons4(Data_Argonaut_Encode_Class.gEncodeJsonNil)(statsPassiveIsSymbol)())(statsActiveIsSymbol)())(speedIsSymbol)())(jitterIsSymbol)())())))))))))
};
var decodeJsonLoadOutput = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericLoadOutput_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(CurrentIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Bytes.decodeJsonBytes))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(decodeRecord)))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeRecord))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(totalSpeedIsSymbol)()())(streamSpeedsIsSymbol)()())(bytesIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(TotalIntermediateIsSymbol)(decodeRecord))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StreamIntermediateIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons3(gDecodeJsonCons2)(streamIndexIsSymbol)()())(speedIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(IntermediateStatsPassiveIsSymbol)(Data_TransmissionStats.decodeJsonTransmissionSta))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(IntermediateStatsActiveIsSymbol)(Data_TransmissionStats.decodeJsonTransmissionSta))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(WarningIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_FSValue.decodeJsonFSWarning))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(warningIsSymbol)()())(timestampIsSymbol)()())(streamIndexIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(FinalIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(Data_Argonaut_Decode_Class.gDecodeJsonNil)(statsPassiveIsSymbol)()())(statsActiveIsSymbol)()())(speedIsSymbol)()())(jitterIsSymbol)()())()))))))))
};
var timeoutLoadedBytes = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var MonadRec1 = MonadAppNE4.MonadRec1();
    var forever = Control_Monad_Rec_Class.forever(MonadRec1);
    var discard1 = discard(Bind1);
    var MonadTime2 = MonadAppNE4.MonadTime2();
    var delay = WE_Class_Time.delay(MonadTime2);
    var now = WE_Class_Time.now(MonadTime2);
    var put = WE_Class_AVar.put(ManageAVar3);
    var bracket = Control_Monad_Fork_Class.bracket(dictMonadApp.MonadBracket2());
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var tailRecM = Control_Monad_Rec_Class.tailRecM(MonadRec1);
    var take = WE_Class_AVar.take(ManageAVar3);
    return function (timeout) {
        return function (inputStreamer) {
            return bind(empty)(function (av) {
                var timeoutHandler = forever(discard1(delay(timeout))(function () {
                    return bind(now)(function (timestamp) {
                        return put({
                            payload: new MST_Data_StreamEvent.LoadedBytes(mempty),
                            timestamp: timestamp
                        })(av);
                    });
                }));
                var loop = function (tof) {
                    return bind(bracket(pure(Data_Unit.unit))(function (v) {
                        return function (v1) {
                            return for_(tof)(kill_);
                        };
                    })(function (v) {
                        return Fusion_Generator.next(inputStreamer);
                    }))(function (streamEvent) {
                        return discard1(put(streamEvent)(av))(function () {
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.Start) {
                                return pure(new Control_Monad_Rec_Class.Loop(Data_Maybe.Nothing.value));
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.ResponseStart) {
                                return bind(fork(timeoutHandler))(function (nTof) {
                                    return pure(new Control_Monad_Rec_Class.Loop(new Data_Maybe.Just(nTof)));
                                });
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.LoadedBytes) {
                                return bind(fork(timeoutHandler))(function (nTof) {
                                    return pure(new Control_Monad_Rec_Class.Loop(new Data_Maybe.Just(nTof)));
                                });
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.ResponseEnd) {
                                return pure(new Control_Monad_Rec_Class.Done(Data_Unit.unit));
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.Fail) {
                                return pure(new Control_Monad_Rec_Class.Done(Data_Unit.unit));
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.Abort) {
                                return pure(new Control_Monad_Rec_Class.Done(Data_Unit.unit));
                            };
                            if (streamEvent.payload instanceof MST_Data_StreamEvent.TransmissionStats) {
                                return pure(new Control_Monad_Rec_Class.Loop(Data_Maybe.Nothing.value));
                            };
                            throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 490, column 7 - line 506, column 30): " + [ streamEvent.payload.constructor.name ]);
                        });
                    });
                };
                return bind(fork(tailRecM(loop)(Data_Maybe.Nothing.value)))(function (fiber) {
                    return pure({
                        next: take(av),
                        cancel: discard1(Fusion_Generator.cancel(inputStreamer))(function () {
                            return kill_(fiber);
                        })
                    });
                });
            });
        };
    };
};
var engineStreamer = function (dictMonadApp) {
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadKill3 = dictMonadApp.MonadKill3();
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var form2toForm1 = Fusion_Generator.form2toForm1(MonadAppNE4.ManageAVar3())(MonadAppNE4.MonadFork0())(MonadKill3)(MonadBracket2.MonadError1());
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = discard(Bind1);
    var throwError = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var bind = Control_Bind.bind(Bind1);
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableArray);
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    return function (engineConnection) {
        return function (loadDirection) {
            return function (url) {
                return form2toForm1(function (emit) {
                    return discard1((function () {
                        if (loadDirection instanceof Data_LoadDirection.DownloadP) {
                            return engineConnection.send(new MST_Data_EngineCommunication.StartDownloadStream({
                                url: url
                            }));
                        };
                        if (loadDirection instanceof Data_LoadDirection.UploadP) {
                            return engineConnection.send(new MST_Data_EngineCommunication.StartUploadStream({
                                url: url,
                                byteCount: loadDirection.value0.byteCount
                            }));
                        };
                        throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 343, column 3 - line 352, column 10): " + [ loadDirection.constructor.name ]);
                    })())(function () {
                        var streamStarted = function (ece) {
                            var v = new Data_Tuple.Tuple(loadDirection, ece);
                            if (v.value0 instanceof Data_LoadDirection.DownloadP && v.value1 instanceof MST_Data_EngineCommunication.StartedDownloadStream) {
                                return new Data_Maybe.Just({
                                    streamId: v.value1.value0.streamId,
                                    url: v.value1.value0.url
                                });
                            };
                            if (v.value0 instanceof Data_LoadDirection.UploadP && v.value1 instanceof MST_Data_EngineCommunication.StartedUploadStream) {
                                return new Data_Maybe.Just({
                                    streamId: v.value1.value0.streamId,
                                    url: v.value1.value0.url
                                });
                            };
                            return Data_Maybe.Nothing.value;
                        };
                        var getMessage = function (ece) {
                            if (ece instanceof MST_Data_EngineCommunication.Open) {
                                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl56.value)("expecting an open engine connection, but got Open EngineConnectionEvent"));
                            };
                            if (ece instanceof MST_Data_EngineCommunication.Close) {
                                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl57.value)("expecting an open engine connection, but got Close EngineConnectionEvent"));
                            };
                            if (ece instanceof MST_Data_EngineCommunication.ConnectionFailure) {
                                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.EnCn50.value)("Engine connection failure: " + show(ece.value0)));
                            };
                            if (ece instanceof MST_Data_EngineCommunication.Message) {
                                return pure(ece.value0.message);
                            };
                            throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 371, column 7 - line 375, column 44): " + [ ece.constructor.name ]);
                        };
                        var $lazy_waitForStreamId = $runtime_lazy("waitForStreamId", "Fusion.LoadIntermediate", function () {
                            return bind(engineConnection.recv)(function (ece) {
                                return bind(getMessage(ece))(function (msg) {
                                    var v = streamStarted(msg);
                                    if (v instanceof Data_Maybe.Just && eq7(v.value0.url)(url)) {
                                        return pure(v.value0.streamId);
                                    };
                                    return $lazy_waitForStreamId(384);
                                });
                            });
                        });
                        var waitForStreamId = $lazy_waitForStreamId(378);
                        return bind(waitForStreamId)(function (streamId) {
                            var $lazy_loop = $runtime_lazy("loop", "Fusion.LoadIntermediate", function () {
                                return bind(engineConnection.recv)(function (ece) {
                                    return bind(getMessage(ece))(function (msg) {
                                        if (msg instanceof MST_Data_EngineCommunication.NetworkReport) {
                                            var myEvents = Data_Maybe.fromMaybe([  ])(lookup(streamId)(msg.value0.batch));
                                            return discard1(for_(Data_Array.reverse(myEvents))(function (event) {
                                                return emit(event);
                                            }))(function () {
                                                var v = Data_Array.head(myEvents);
                                                if (v instanceof Data_Maybe.Nothing) {
                                                    return $lazy_loop(404);
                                                };
                                                if (v instanceof Data_Maybe.Just) {
                                                    if (v.value0.payload instanceof MST_Data_StreamEvent.ResponseEnd) {
                                                        return pure(Data_Unit.unit);
                                                    };
                                                    if (v.value0.payload instanceof MST_Data_StreamEvent.Fail) {
                                                        return pure(Data_Unit.unit);
                                                    };
                                                    if (v.value0.payload instanceof MST_Data_StreamEvent.Abort) {
                                                        return pure(Data_Unit.unit);
                                                    };
                                                    return $lazy_loop(409);
                                                };
                                                throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 403, column 11 - line 409, column 24): " + [ v.constructor.name ]);
                                            });
                                        };
                                        return $lazy_loop(410);
                                    });
                                });
                            });
                            var loop = $lazy_loop(389);
                            return bracket(pure(Data_Unit.unit))(function (bracketCondition) {
                                return function (v) {
                                    if (bracketCondition instanceof Control_Monad_Fork_Class.Killed) {
                                        return engineConnection.send(new MST_Data_EngineCommunication.StopStream({
                                            streamId: streamId
                                        }));
                                    };
                                    return pure(Data_Unit.unit);
                                };
                            })(function (v) {
                                return loop;
                            });
                        });
                    });
                });
            };
        };
    };
};
var currentAndIntermediateSpeed = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Applicative0 = Monad0.Applicative0();
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var update = Fusion_DataProcessing.update((dictMonadApp.MonadBracket2()).MonadError1());
    var discard1 = discard(Bind1);
    var pure = Control_Applicative.pure(Applicative0);
    var when = Control_Applicative.when(Applicative0);
    var throwError = Control_Monad_Error_Class.throwError((dictMonadApp.MonadKill3()).MonadThrow1());
    return function (coalesceInterval) {
        return function (streamer) {
            return function (emit) {
                var emitIntermediate = function (sdp) {
                    return for_(sdp)(function (cs) {
                        return emit(new SLOIntermediate(cs));
                    });
                };
                var loop = function (state) {
                    return bind(Fusion_Generator.next(streamer))(function (event) {
                        if (event.payload instanceof MST_Data_StreamEvent.LoadedBytes) {
                            return bind(update({
                                coalesceInterval: coalesceInterval
                            })({
                                loadedBytes: event.payload.value0.bytes,
                                timestamp: event.timestamp
                            })(state))(function (newState) {
                                var mcs = Fusion_DataProcessing.currentSpeed(newState);
                                return discard1(for_(mcs)(function (v) {
                                    return emit(new SLOCurrent({
                                        speed: v.speed,
                                        timestamp: v.timestamp,
                                        loadedBytes: event.payload.value0.bytes
                                    }));
                                }))(function () {
                                    return discard1(emitIntermediate(Fusion_DataProcessing.intermediateSpeed({
                                        coalesceInterval: coalesceInterval
                                    })(newState)))(function () {
                                        return loop(newState);
                                    });
                                });
                            });
                        };
                        if (event.payload instanceof MST_Data_StreamEvent.TransmissionStats) {
                            return discard1(emit(new SLOIntermediateStatsActive(Data_TcpStatsResult.mkTransStats(event.payload.value0.stats))))(function () {
                                return loop(state);
                            });
                        };
                        if (event.payload instanceof MST_Data_StreamEvent.ResponseEnd) {
                            return discard1(emitIntermediate(Fusion_DataProcessing.windowSpeed(state)))(function () {
                                return pure(Completed.value);
                            });
                        };
                        if (event.payload instanceof MST_Data_StreamEvent.Abort) {
                            return discard1(emitIntermediate(Fusion_DataProcessing.windowSpeed(state)))(function () {
                                return pure(Aborted.value);
                            });
                        };
                        if (event.payload instanceof MST_Data_StreamEvent.Fail) {
                            return discard1(emitIntermediate(Fusion_DataProcessing.windowSpeed(state)))(function () {
                                return pure(new Failed(event.payload.value0.message));
                            });
                        };
                        return loop(state);
                    });
                };
                return bind(Fusion_Generator.next(streamer))(function (firstEvent) {
                    if (firstEvent.payload instanceof MST_Data_StreamEvent.Abort) {
                        return pure(Aborted.value);
                    };
                    if (firstEvent.payload instanceof MST_Data_StreamEvent.Fail) {
                        return pure(new Failed(firstEvent.payload.value0.message));
                    };
                    return discard1(when(notEq(firstEvent.payload)(MST_Data_StreamEvent.Start.value))(throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl58.value)("First streamer event must be SE.Start, was: " + show1(firstEvent)))))(function () {
                        return bind(Fusion_Generator.next(streamer))(function (secondEvent) {
                            if (secondEvent.payload instanceof MST_Data_StreamEvent.Abort) {
                                return pure(Aborted.value);
                            };
                            if (secondEvent.payload instanceof MST_Data_StreamEvent.Fail) {
                                return pure(new Failed(secondEvent.payload.value0.message));
                            };
                            return discard1(when(notEq(secondEvent.payload)(MST_Data_StreamEvent.ResponseStart.value))(throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl59.value)("Second streamer event must be SE.ResponseStart, was: " + show1(secondEvent)))))(function () {
                                return loop(Fusion_DataProcessing.initialNtmStreamModel(secondEvent.timestamp));
                            });
                        });
                    });
                });
            };
        };
    };
};
var streamProcessor = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var MonadRef4 = MonadAppNE4.MonadRef4();
    var $$new = WE_Class_MonadRef["new"](MonadRef4);
    var Applicative0 = Monad0.Applicative0();
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var catchError = Control_Monad_Error_Class.catchError(MonadBracket2.MonadError1());
    var fetchTcpStats = Fusion_Class_MonadApp.fetchTcpStats(MonadAppNE4.MonadFetchTcpStats6());
    var pure = Control_Applicative.pure(Applicative0);
    var read = WE_Class_MonadRef.read(MonadRef4);
    var discard1 = discard(Bind1);
    var put = WE_Class_MonadRef.put(MonadRef4);
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var delay = WE_Class_Time.delay(MonadAppNE4.MonadTime2());
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    var timeoutLoadedBytes1 = timeoutLoadedBytes(dictMonadApp);
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    var currentAndIntermediateSpeed1 = currentAndIntermediateSpeed(dictMonadApp);
    return function (mkStreamer) {
        return function (v) {
            return function (emitLoadOutput) {
                var coalesceInterval = Fusion_Data_Duration.fromMs(500.0);
                return bind($$new(Data_Maybe.Nothing.value))(function (prevStatRef) {
                    var fetchAndEmitStats = for_(v.urls.stats)(function (url) {
                        return bind(catchError(bind(fetchTcpStats(url))(function (s) {
                            return pure(new Data_Maybe.Just(s));
                        }))(function (v1) {
                            return pure(Data_Maybe.Nothing.value);
                        }))(function (v1) {
                            return for_(v1)(function (stats) {
                                return bind(read(prevStatRef))(function (mPrevStats) {
                                    return discard1(put(prevStatRef)(new Data_Maybe.Just(stats.latestStats)))(function () {
                                        var prevStats = Data_Maybe.fromMaybe(stats.startStats)(mPrevStats);
                                        var deltaStats = Data_TransmissionStats.subtract(stats.latestStats)(prevStats);
                                        return emitLoadOutput(new SLOIntermediateStatsPassive(deltaStats));
                                    });
                                });
                            });
                        });
                    });
                    var fetchStatsPeriodically = forever(discard1(delay(Fusion_Data_Duration.fromMs(1000.0)))(function () {
                        return fetchAndEmitStats;
                    }));
                    return bind(bracket(bind(mkStreamer(v.urls.load))(function (untimedStreamer) {
                        return bind((function () {
                            if (v.engineType instanceof MST_Data_EngineCommunication.Local) {
                                return timeoutLoadedBytes1(Fusion_Data_Duration.scale(2)(coalesceInterval));
                            };
                            if (v.engineType instanceof MST_Data_EngineCommunication.Remote) {
                                return pure;
                            };
                            throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 307, column 13 - line 309, column 31): " + [ v.engineType.constructor.name ]);
                        })()(untimedStreamer))(function (streamer) {
                            return bind(fork(fetchStatsPeriodically))(function (statsFiber) {
                                return pure(new Data_Tuple.Tuple(streamer, statsFiber));
                            });
                        });
                    }))(function (bracketCondition) {
                        return function (v1) {
                            return discard1(kill_(v1.value1))(function () {
                                if (bracketCondition instanceof Control_Monad_Fork_Class.Completed) {
                                    return discard1(fetchAndEmitStats)(function () {
                                        return emitLoadOutput(new SLOFinished(bracketCondition.value0));
                                    });
                                };
                                if (bracketCondition instanceof Control_Monad_Fork_Class.Failed) {
                                    return discard1(fetchAndEmitStats)(function () {
                                        return emitLoadOutput(new SLOFinished(new Failed(show2(bracketCondition.value0))));
                                    });
                                };
                                if (bracketCondition instanceof Control_Monad_Fork_Class.Killed) {
                                    return discard1(Fusion_Generator.cancel(v1.value0))(function () {
                                        return pure(Data_Unit.unit);
                                    });
                                };
                                throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 317, column 9 - line 326, column 22): " + [ bracketCondition.constructor.name ]);
                            });
                        };
                    })(function (v1) {
                        return currentAndIntermediateSpeed1(coalesceInterval)(v1.value0)(emitLoadOutput);
                    }))(function () {
                        return pure(Data_Unit.unit);
                    });
                });
            };
        };
    };
};
var broadcastEngineConnection = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var Applicative0 = Monad0.Applicative0();
    var sequence1 = sequence(Applicative0);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var $$void = Data_Functor["void"]((Bind1.Apply0()).Functor0());
    var put = WE_Class_AVar.put(ManageAVar3);
    var take = WE_Class_AVar.take(ManageAVar3);
    var pure = Control_Applicative.pure(Applicative0);
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    return function (count) {
        return function (inputConnection) {
            return bind(sequence1(Data_Array.replicate(count)(empty)))(function (recvAvs) {
                return bind(fork(forever(bind(inputConnection.recv)(function (ece) {
                    var putEce = function (av) {
                        return $$void(fork(put(ece)(av)));
                    };
                    return sequence1(map(putEce)(recvAvs));
                }))))(function (fiber) {
                    var mkConnection = function (av) {
                        return {
                            send: inputConnection.send,
                            recv: take(av),
                            engineType: inputConnection.engineType
                        };
                    };
                    return pure({
                        connections: map(mkConnection)(recvAvs),
                        cancel: kill_(fiber)
                    });
                });
            });
        };
    };
};
var loadIntermediate = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var put = WE_Class_AVar.put(ManageAVar3);
    var MonadRef4 = MonadAppNE4.MonadRef4();
    var $$new = WE_Class_MonadRef["new"](MonadRef4);
    var broadcastEngineConnection1 = broadcastEngineConnection(dictMonadApp);
    var catchError = Control_Monad_Error_Class.catchError((dictMonadApp.MonadBracket2()).MonadError1());
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var randomUUIDv4 = WE_Class_Random.randomUUIDv4(MonadAppNE4.MonadRandom5());
    var modify = WE_Class_MonadRef.modify(MonadRef4);
    var discard1 = discard(Bind1);
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var now = WE_Class_Time.now(MonadAppNE4.MonadTime2());
    var modify_ = WE_Class_MonadRef.modify_(MonadRef4);
    var engineStreamer1 = engineStreamer(dictMonadApp);
    var streamProcessor1 = streamProcessor(dictMonadApp);
    var read = WE_Class_MonadRef.read(MonadRef4);
    var when = Control_Applicative.when(Applicative0);
    var MonadKill3 = dictMonadApp.MonadKill3();
    var throwError = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var parOneOf = Fusion_Class_MonadApp.parOneOf(MonadAppNE4.MonadRaceInParallel7())(Data_Traversable.traversableArray)(Data_FunctorWithIndex.functorWithIndexArray)(Data_Eq.eqInt);
    var take = WE_Class_AVar.take(ManageAVar3);
    var kill_ = Fusion_Generator.kill_(MonadKill3);
    return function (engineConnection) {
        return function (loadDirection) {
            return function (v) {
                return bind(empty)(function (av) {
                    var emit = function (v1) {
                        return put(new Data_Either.Right(v1))(av);
                    };
                    return bind($$new(Data_Array.replicate(v.countStreams)({
                        speed: mempty1,
                        timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                    })))(function (v1) {
                        return bind($$new(Data_Array.replicate(v.countStreams)({
                            speed: mempty1,
                            timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                        })))(function (v2) {
                            return bind($$new(mempty2))(function (v3) {
                                return bind($$new(0))(function (v4) {
                                    var streamUrls = fromFoldable(Data_List_Lazy.take(v.countStreams)(Data_List_Lazy.cycle(fromFoldable1(v.urls))));
                                    return bind(broadcastEngineConnection1(v.countStreams)(engineConnection))(function (streamPrivatEngineConnections) {
                                        var indexUrlsConns = Data_Array.mapWithIndex(function (index) {
                                            return function (v5) {
                                                return {
                                                    index: index,
                                                    url: v5.value0,
                                                    conn: v5.value1
                                                };
                                            };
                                        })(Data_Array.zip(streamUrls)(streamPrivatEngineConnections.connections));
                                        var streamHandlers = mapFlipped(indexUrlsConns)(function (v5) {
                                            return Data_Function.flip(catchError)(function (err) {
                                                return put(new Data_Either.Left(err))(av);
                                            })(forever(bind(randomUUIDv4)(function (uuid) {
                                                var cid = Data_UUID_Random.toString(uuid);
                                                var urlsWithCid = {
                                                    load: MST_Data_BasicURL.addQueryParameter("connectionId")(new Data_Maybe.Just(cid))(v5.url.load),
                                                    stats: map1(MST_Data_BasicURL.addPathSegment(URI_Path_Segment.segmentFromString(cid)))(v5.url.stats)
                                                };
                                                var emitStream = function (v6) {
                                                    if (v6 instanceof SLOCurrent) {
                                                        return bind(modify(v1)(updateAtIndices([ new Data_Tuple.Tuple(v5.index, {
                                                            speed: v6.value0.speed,
                                                            timestamp: v6.value0.timestamp
                                                        }) ])))(function (newSpeeds) {
                                                            var totalSpeed = fold(map(function (v7) {
                                                                return v7.speed;
                                                            })(newSpeeds));
                                                            var latestTimestamp = Data_Array.foldl(max)(Fusion_Data_Timestamp.timeIntervalSince1970(mempty3))(map(function (v7) {
                                                                return v7.timestamp;
                                                            })(newSpeeds));
                                                            return bind(modify(v3)(append1(v6.value0.loadedBytes)))(function (bytes) {
                                                                return emit(new Current({
                                                                    totalSpeed: {
                                                                        speed: totalSpeed,
                                                                        timestamp: latestTimestamp
                                                                    },
                                                                    streamSpeeds: newSpeeds,
                                                                    bytes: bytes
                                                                }));
                                                            });
                                                        });
                                                    };
                                                    if (v6 instanceof SLOIntermediate) {
                                                        return bind(modify(v2)(updateAtIndices([ new Data_Tuple.Tuple(v5.index, {
                                                            speed: v6.value0.speed,
                                                            timestamp: v6.value0.timestamp
                                                        }) ])))(function (newSpeeds) {
                                                            var totalSpeed = fold(map(function (v7) {
                                                                return v7.speed;
                                                            })(newSpeeds));
                                                            var latestTimestamp = Data_Array.foldl(max)(Fusion_Data_Timestamp.timeIntervalSince1970(mempty3))(map(function (v7) {
                                                                return v7.timestamp;
                                                            })(newSpeeds));
                                                            return discard1(emit(new StreamIntermediate({
                                                                speed: v6.value0.speed,
                                                                timestamp: v6.value0.timestamp,
                                                                streamIndex: v5.index
                                                            })))(function () {
                                                                return emit(new TotalIntermediate({
                                                                    speed: totalSpeed,
                                                                    timestamp: latestTimestamp
                                                                }));
                                                            });
                                                        });
                                                    };
                                                    if (v6 instanceof SLOIntermediateStatsPassive) {
                                                        return emit(new IntermediateStatsPassive(v6.value0));
                                                    };
                                                    if (v6 instanceof SLOIntermediateStatsActive) {
                                                        return emit(new IntermediateStatsActive(v6.value0));
                                                    };
                                                    if (v6 instanceof SLOFinished && v6.value0 instanceof Completed) {
                                                        return pure(Data_Unit.unit);
                                                    };
                                                    if (v6 instanceof SLOFinished && v6.value0 instanceof Aborted) {
                                                        return pure(Data_Unit.unit);
                                                    };
                                                    if (v6 instanceof SLOFinished && v6.value0 instanceof Failed) {
                                                        var warning = (function () {
                                                            if (loadDirection instanceof Data_LoadDirection.DownloadP) {
                                                                return new Fusion_Data_FSValue.FSWarningDownloadStreamFailed(urlsWithCid.load, v6.value0.value0);
                                                            };
                                                            if (loadDirection instanceof Data_LoadDirection.UploadP) {
                                                                return new Fusion_Data_FSValue.FSWarningUploadStreamFailed(urlsWithCid.load, v6.value0.value0);
                                                            };
                                                            throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 221, column 31 - line 223, column 84): " + [ loadDirection.constructor.name ]);
                                                        })();
                                                        return bind(now)(function (timestamp) {
                                                            return discard1(emit(new Warning({
                                                                warning: warning,
                                                                timestamp: timestamp,
                                                                streamIndex: v5.index
                                                            })))(function () {
                                                                return modify_(v4)(add(1));
                                                            });
                                                        });
                                                    };
                                                    throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 172, column 28 - line 232, column 55): " + [ v6.constructor.name ]);
                                                };
                                                var mkStreamer = engineStreamer1(v5.conn)(loadDirection);
                                                return discard1(streamProcessor1(mkStreamer)({
                                                    urls: urlsWithCid,
                                                    engineType: engineConnection.engineType
                                                })(emitStream))(function () {
                                                    return bind(read(v4))(function (nw) {
                                                        return when(nw >= (v.countStreams + 1 | 0))((function () {
                                                            if (loadDirection instanceof Data_LoadDirection.DownloadP) {
                                                                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.DnCn51.value)("Too much download streams failed"));
                                                            };
                                                            if (loadDirection instanceof Data_LoadDirection.UploadP) {
                                                                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.UpCn51.value)("Too much upload streams failed"));
                                                            };
                                                            throw new Error("Failed pattern match at Fusion.LoadIntermediate (line 247, column 15 - line 251, column 90): " + [ loadDirection.constructor.name ]);
                                                        })());
                                                    });
                                                });
                                            })));
                                        });
                                        return bind(fork(parOneOf(streamHandlers)))(function (streamsFiber) {
                                            return pure({
                                                next: take(av),
                                                cancel: discard1(kill_(streamsFiber))(function () {
                                                    return streamPrivatEngineConnections.cancel;
                                                })
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            };
        };
    };
};
export {
    Current,
    TotalIntermediate,
    StreamIntermediate,
    IntermediateStatsPassive,
    IntermediateStatsActive,
    Warning,
    Final,
    Completed,
    Aborted,
    Failed,
    SLOCurrent,
    SLOIntermediate,
    SLOIntermediateStatsPassive,
    SLOIntermediateStatsActive,
    SLOFinished,
    loadIntermediate,
    streamProcessor,
    timeoutLoadedBytes,
    genericLoadOutput_,
    encodeJsonLoadOutput,
    decodeJsonLoadOutput,
    showLoadOutput,
    eqLoadOutput,
    genericStreamLoadOutput_,
    showStreamLoadOutput,
    genericStreamCompletionMa,
    showStreamCompletionManne,
    isFinalLoadOutput,
    isFinalStreamLoadOutput
};
